import React from 'react';
import axios from 'axios';
import { Globe } from 'lucide-react';
import { LANGUAGES, getLanguage, setLanguage } from '@/i18n';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { API } from '@/constants';

export default function LanguageSwitcher({ className = '', variant = 'light' }) {
  const current = getLanguage();
  const active = LANGUAGES.find((l) => l.code === current) || LANGUAGES[0];

  const choose = async (code) => {
    if (code === current) return;
    try {
      if (localStorage.getItem('token')) {
        await axios.patch(`${API}/users/me/settings`, { settings: { preferred_language: code } });
      }
    } catch (_) { /* language still applies locally */ }
    setLanguage(code);
  };

  const tone = variant === 'dark'
    ? 'text-slate-200 hover:text-white hover:bg-white/10'
    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm font-medium transition-colors ${tone} ${className}`}
          aria-label="Change language"
          data-testid="language-switcher"
        >
          <Globe className="h-4 w-4" />
          <span>{active.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => choose(l.code)}
            className={l.code === current ? 'font-semibold text-[#1e3a5f]' : ''}
            data-testid={`language-option-${l.code}`}
          >
            <span className="w-8 text-xs text-slate-400">{l.short}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
